import { RestClient } from '@pegasus/rest-client';
export const loadUserTrackingData = async (clientId = 'me') => {
    const data = (await RestClient.get(`/api/tracking/clients/${clientId}/events`)
        .withSpanName('GET - /api/tracking/clients/{clientId}/events')
        .withSpanAttributes([{ name: 'clientId', value: clientId }])
        .withHeaders({ 'Content-Type': 'application/json' })
        .acceptStatusCodes([200])
        .send()
        .then(data => data.json()));
    return data;
};
export const loadGA4UserTrackingData = async () => {
    try {
        const response = await RestClient.get('/api/tracking/clients/me/events/ga4')
            .acceptStatusCodes([200])
            .send();
        const dataLayer = await response.json();
        const lead = response.headers.get('X-Lead-Event') === 'true';
        return { dataLayer, lead };
    }
    catch (e) {
        return { dataLayer: {}, lead: false };
    }
};
//# sourceMappingURL=api.js.map